<template>
  <v-card class="channels_card ma-2 ma-sm-3 mb-6 mb-sm-12" elevation="0">
    <v-posts-loader :active="loading ? 'active' : ''" :st="'height: 100px; '" class="row"></v-posts-loader>
    <v-row
        class="
        px-5 px-sm-8
        pt-10 pt-lg-7
        pb-5 pb-lg-5
        d-block d-lg-flex
        align-center
        card_title
      "
    >
      <template v-if="!add_new_account && !loading">
        <v-col lg="6" class="d-none d-lg-flex mb-lg-4">
          Name account
        </v-col>
        <v-col class="d-none d-lg-flex justify-center mb-lg-4">
          Followers
        </v-col>
        <v-col
            lg="3"
            class="d-flex justify-center mb-lg-4 justify-lg-end"
        >
          <v-btn
              class="add_account_btn mb-4 mb-lg-0"
              rounded
              height="60px"
              color="#76CD68"
              dark
              depressed
              @click="addNewAccount()"
          >
            Add new account
          </v-btn>
        </v-col>
      </template>

      <template v-if="add_new_account">
        <v-col v-if="!loading" class="pr-lg-5">
          <v-text-field
              class="text_field mb-lg-4"
              color="#8596B7"
              :label="
                            $vuetify.breakpoint.lgAndUp
                                ? '@username and press Check'
                                : '@username'
                        "
              rounded
              single-line
              outlined
              hide-details=""
              v-model="new_channel_name"
          ></v-text-field>
        </v-col>
        <v-col
            v-if="!loading"
            lg="auto"
            class="d-flex justify-space-between justify-lg-end"
        >
          <v-btn
              class="add_account_btn mb-4"
              height="60px"
              :width="$vuetify.breakpoint.xs ? '73%' : '165px'"
              rounded
              color="#76CD68"
              dark
              depressed
              @click="addAccount()"
          >
            Check
          </v-btn>
          <v-btn
              color="#8391AE"
              width="60"
              height="60"
              class="close_btn ml-4"
              outlined
              @click="add_new_account = false"
          >
            <img src="../assets/plus-symbol.svg" alt="close"/>
          </v-btn>
        </v-col>
      </template>
    </v-row>
    <v-divider class="divider d-none d-lg-block"></v-divider>

    <template v-if="!accounts.data || accounts.data.length === 0">
      <div class="no_accounts text-center py-12">
          <template v-if="accounts_loading">
            Loading...
          </template>
          <template v-else>
              No accounts
          </template>
      </div>
    </template>

    <template v-else>
      <div
          :class="'mx-5 mx-sm-0 channel_list_item item' + index"
          v-for="(channel, index) in accounts.data"
          :key="index"
      >
        <v-row
            class="py-7 pt-5 mt-0 px-2 px-sm-8 d-block d-lg-flex align-center"
        >
          <div
              class="removing_overlay mx-4 ma-lg-0"
              :style="{
                            borderRadius: $vuetify.breakpoint.lgAndUp
                                ? '0'
                                : '20px'
                        }"
          >
            <v-row class="d-block d-lg-flex px-4 px-lg-11">
              <div
                  class="
                  remove_text
                  d-lg-flex
                  align-lg-center
                  flex-grow-0
                  text-center
                  px-15 px-lg-0
                "
              >
                Are you sure to delete this account?
              </div>
              <div
                  class="
                  col
                  d-flex
                  justify-space-between
                  flex-grow-1
                  px-5
                  pr-lg-0
                "
              >
                <v-btn
                    class="remove_account_btn ml-lg-2"
                    height="50px"
                    rounded
                    :width="
                                        !$vuetify.breakpoint.lgAndUp
                                            ? '113px'
                                            : '136px'
                                    "
                    color="#9F4343"
                    depressed
                    dark
                    @click="removeChannel(index)"
                >
                  Yes
                </v-btn>
                <v-btn
                    class="remove_account_btn"
                    height="50px"
                    :width="
                                        !$vuetify.breakpoint.lgAndUp
                                            ? '113px'
                                            : '136px'
                                    "
                    rounded
                    outlined
                    color="#9F4343"
                    depressed
                    @click="closeRemoveOverlay(index)"
                >
                  No
                </v-btn>
              </div>
            </v-row>
          </div>
          <v-col
              lg="6"
              class="d-block d-lg-flex align-center text-center c-pointer"
          >
            <img
                class="mr-lg-7 avatar"
                :src="channel.avatar"
                alt="avatar"
                @click="goChanel(index)"
            />
            <div class="channel_name mt-lg-2" @click="goChanel(index)">
              {{ channel.account }}
            </div>
          </v-col>
          <v-col class="d-flex py-0 followers justify-center">
            <img
                class="ml-n7 ml-lg-0 mr-3"
                src="../assets/followers.svg"
                alt="icon"
            />
            <div>{{ channel.followed_by_count }}</div>
          </v-col>
          <v-col
              lg="3"
              class="d-flex mb-0 justify-center justify-lg-end"
          >
            <v-btn
                class="remove_account_btn"
                height="50px"
                width="136px"
                rounded
                color="#8391AE"
                outlined
                depressed
                @click="openRemoveOverlay(index)"
            >
              Remove
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="divider"></v-divider>
      </div>
      <template v-if="accounts.current_page < accounts.last_page">
        <v-row
            v-if="$vuetify.breakpoint.lgAndUp"
            class="py-14 d-flex justify-center"
        >
          <v-btn
              class="buy_btn mb-3 mb-lg-0 mr-lg-2"
              width="189px"
              height="60px"
              outlined
              rounded
              color="#2C4370"
              @click="loadMore(accounts.current_page + 1)"
          >
            Load more
          </v-btn>
        </v-row>
        <v-row
            class="load_more_mobile"
            v-if="!$vuetify.breakpoint.lgAndUp"
        >
          <v-btn
              class="buy_btn"
              width="189px"
              height="60px"
              outlined
              rounded
              color="#2C4370"
              @click="loadMore(accounts.current_page + 1)"
          >
            Load more
          </v-btn>
        </v-row>
      </template>
    </template>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getTiktokLoginUrl, getTiktokUser } from '@/api/accounts.js'
import {showError, showSuccess} from '@/utils/notifications'
import PostsLoader from './PostsLoader'

export default {
  name: 'AccountChart',
  props: ['type'],
  components: {
    'v-posts-loader': PostsLoader,
  },
  data () {
    if (this.type === 'tiktok') {
      getTiktokLoginUrl()
    }
    return {
      loading: false,
      account_loading: false,
      accounts_loading: false,
      add_new_account: false,
      removing_overlay: false,
      new_channel_name: null
    }
  },

  computed: {
    ...mapGetters('accounts', ['accounts'])
  },

  async created () {
    this.clearAccountsData()
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (code) {
      console.log(code);
      this.listLoading = true;
      try {
        const userId = await getTiktokUser(code);
       // window.location.href = '/account/tiktok';
        console.log(userId);
      } catch (e) {
       // window.location.href = '/account/tiktok';
        this.listLoading = false;
      }
      this.listLoading = false;
    }
    this.handleLoadAccounts()
  },
  watch: {
    '$route': function () {
      this.clearAccountsData()
      this.handleLoadAccounts()
    },
  },
  methods: {
    ...mapActions('accounts', [
      'loadAccounts',
      'clearAccountsData',
      'deleteAccount',
      'findInstagramAccount',
      'addInstagramAccount',
      'findTiktokAccount',
      'addTiktokAccount',
    ]),

    async addNewAccount () {
      this.add_new_account = true;
    },

    goChanel (index) {
      this.$router.push('/' + this.type + '/' + index)
    },

    handleLoadAccounts (page = 1) {
      if (this.accounts_loading) {
        return
      }
      this.accounts_loading = true

      this.loadAccounts({ page, type: this.type })
          .then(() => (this.accounts_loading = false))
          .catch(() => (this.accounts_loading = false))
    },

    loadMore (page) {
      this.handleLoadAccounts({ page, type: this.type })
    },

    addAccount () {
      if (!this.new_channel_name || !this.new_channel_name.length) {
        return
      }
      this.loading = true
      const type = this.type.charAt(0).toUpperCase() + this.type.slice(1)

      const array1 = ['https://', 'www.', '@', '/?hl=en', `${this.type}.com/`]
      for (const element of array1) {
        this.new_channel_name = this.new_channel_name.replace(element, '')
      }
      this.new_channel_name = this.new_channel_name.replace(/\/$/, '').trim()
      let timeoutID;
      this[`find${type}Account`](this.new_channel_name).then(response => {
        if (response === false) {
          showError('Check correct account, or add another please')
          this.account_loading = false
          this.loading = false
        }

        if (response.error) {
          showError(response.error)
          this.account_loading = false
          this.loading = false
          return
        }

        if (type === 'instagram' && response.graphql != undefined && response.graphql.user.is_private) {
          showError('This account is private, add another please')
          this.account_loading = false
          this.loading = false
          return
        }

        this[`add${type}Account`](response).then(() => {
          this.add_new_account = false
          this.new_channel_name = null
          this.account_loading = false
          this.loading = false
        })
      })
          .catch((e) => {
            clearTimeout(timeoutID);
            console.log('add 335', e)
            this.loading = false
            this.account_loading = false
          })

      timeoutID = setTimeout(() => {
          if (this.loading) {
            showSuccess('Wait we are looking for your account')
          }
        }, 15000)
    },

    openRemoveOverlay (index) {
      let el = document.getElementsByClassName('item' + index)[0]
      el.classList.add('open_overlay')
    },

    closeRemoveOverlay (index) {
      let el = document.getElementsByClassName('item' + index)[0]
      el.classList.remove('open_overlay')
    },

    removeChannel (index) {
      let el = document.getElementsByClassName('item' + index)[0]
      el.classList.remove('open_overlay')
      this.deleteAccount({ index, type: this.type })
    }
  }
}
</script>
<style scoped>
.avatar {
  width: 50px;
  height: 50px;
}

.c-pointer {
  cursor: pointer;
}

.channels_card {
  margin-bottom: 150px !important;
  overflow: visible;
}

.card_title {
  color: #8194b7;
  font-size: 18px;
}

.channel_list_item {
  color: #172745;
  position: relative;
}

.v-btn {
  text-transform: none;
  font-weight: normal;
}

.add_account_btn {
  width: 217px;
  font-size: 18px;
}

.remove_account_btn {
  font-size: 18px;
}

.theme--light.v-divider {
  border-color: #eaeaea !important;
}

.channel_name {
  font-size: 18px;
}

.followers {
  font-size: 24px;
}

.followers img {
  border-radius: 50%;
}

.close_btn {
  min-width: 0 !important;
  border-radius: 50%;
}

.v-text-field--outlined >>> fieldset {
  border: 1px solid #dedede;
}

.text_field >>> .v-label {
  color: #8596b7;
}

.text_field >>> .v-text-field__slot input {
  color: #8596b7;
}

.removing_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f9adad;
  visibility: hidden;
  display: flex;
  opacity: 0;
  z-index: 5;
  color: #582121;
  font-size: 18px;
}

.open_overlay .removing_overlay {
  visibility: visible;
  opacity: 1;
  align-items: center;
  -webkit-transition: visibility 0.5s, opacity 0.5s;
  -moz-transition: visibility 0.5s, opacity 0.5s;
  transition: visibility 0.5s, opacity 0.5s;
}

.no_accounts {
  color: #8194b7;
  font-size: 18px;
}

.load_more_mobile {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -90px;
  display: flex;
  justify-content: center;
}
</style>
